<template>
    <section class="mine-help">
        <div class="mine-help-tip">常见问题</div>
        <help-item
            v-for="(item, index) in textList"
            :key="index"
            :data-source="item"
            @click="handleClick" />
    </section>
</template>

<script>
	/** eslint-disable */
	import HelpItem from '../components/Mine/HelpItem.vue'

	export default {
		name: 'MineHelp',
		components: {
			HelpItem
		},
		data () {
			return {
				textList: [
					{
						title: '课程是否可以重复观看？',
						desc: '所有课程包括直播课、音频课、视频课都支持重复观看'
					},
					{
						title: '课程购买后除了微信还可以在什么地方观看呢？',
						desc: '目前只支持微信平台进行学习哦！'
					},
					{
						title: '课程视频是否提供下载？',
						desc: '很抱歉，由于我们是付费课程，所以无法提供下载'
					}
				]
			}
		},
		methods: {
			handleNavigate (url) {
				this.$router.push(url)
			},
			handleClick (data, index) {
			}
		}
	}
</script>

<style lang="scss" scoped>
    @import '../style/main';

    .mine-help {
        overflow-y: scroll;
        height: 100%;
        background-color: #f3f4f6;
    }

    .mine-help-tip {
        position: relative;
        padding: rem(30) 0 rem(30) rem(30);
        border-bottom: 1px solid #e4e4e4;
        background-color: #fff;
        font-size: rem(28);
        color: #333;

        // &::after {
        //     content: '意见反馈';
        //     transform: translateY(-50%);
        //     position: absolute;
        //     top: 50%;
        //     right: rem(30);
        //     padding-left: rem(42);
        //     background: {
        //         image: url('../assets/images/help-icon-pen.png');
        //         repeat: no-repeat;
        //         size: contain;
        //         position: left center;
        //     }
        //     font-size: rem(28);
        //     font-weight: 600;
        //     color: #f48c00;
        // }
    }

    .mine-help-contact {
        position: relative;
        margin-top: rem(24);
        padding: rem(20) rem(30);
        font-size: rem(24);
        line-height: 1.5;
        background-color: #fff;
        color: #666;

        // &-info {
        //     transform: translateY(-50%);
        //     position: absolute;
        //     top: 50%;
        //     right: rem(30);
        //     line-height: 1.5;
        //     font-size: rem(24);
        //     color: #666;
        // }
    }
</style>
